'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $s_Lapp_layouts_MainLayout$MenuStyle$__Simple__Lapp_layouts_MainLayout$MenuStyle() {
  $m_Lapp_layouts_MainLayout$MenuStyle$();
  return $t_Lapp_layouts_MainLayout$MenuStyle$__Simple;
}
export { $s_Lapp_layouts_MainLayout$MenuStyle$__Simple__Lapp_layouts_MainLayout$MenuStyle as $s_Lapp_layouts_MainLayout$MenuStyle$__Simple__Lapp_layouts_MainLayout$MenuStyle };
function $s_Lapp_layouts_MainLayout$MenuStyle$__Notification__Lapp_layouts_MainLayout$MenuStyle() {
  $m_Lapp_layouts_MainLayout$MenuStyle$();
  return $t_Lapp_layouts_MainLayout$MenuStyle$__Notification;
}
export { $s_Lapp_layouts_MainLayout$MenuStyle$__Notification__Lapp_layouts_MainLayout$MenuStyle as $s_Lapp_layouts_MainLayout$MenuStyle$__Notification__Lapp_layouts_MainLayout$MenuStyle };
/** @constructor */
function $c_Lapp_layouts_MainLayout$MenuStyle$() {
  $n_Lapp_layouts_MainLayout$MenuStyle$ = this;
  $t_Lapp_layouts_MainLayout$MenuStyle$__Simple = new $c_Lapp_layouts_MainLayout$MenuStyle$$anon$1("Simple", 0);
  $t_Lapp_layouts_MainLayout$MenuStyle$__Notification = new $c_Lapp_layouts_MainLayout$MenuStyle$$anon$1("Notification", 1);
  $s_Lapp_layouts_MainLayout$MenuStyle$__Simple__Lapp_layouts_MainLayout$MenuStyle();
  $s_Lapp_layouts_MainLayout$MenuStyle$__Notification__Lapp_layouts_MainLayout$MenuStyle();
}
export { $c_Lapp_layouts_MainLayout$MenuStyle$ as $c_Lapp_layouts_MainLayout$MenuStyle$ };
$c_Lapp_layouts_MainLayout$MenuStyle$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_layouts_MainLayout$MenuStyle$.prototype.constructor = $c_Lapp_layouts_MainLayout$MenuStyle$;
/** @constructor */
function $h_Lapp_layouts_MainLayout$MenuStyle$() {
}
export { $h_Lapp_layouts_MainLayout$MenuStyle$ as $h_Lapp_layouts_MainLayout$MenuStyle$ };
$h_Lapp_layouts_MainLayout$MenuStyle$.prototype = $c_Lapp_layouts_MainLayout$MenuStyle$.prototype;
$c_Lapp_layouts_MainLayout$MenuStyle$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_layouts_MainLayout$MenuStyle$$anon$1__f__$ordinal$1;
});
var $d_Lapp_layouts_MainLayout$MenuStyle$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_layouts_MainLayout$MenuStyle$, "app.layouts.MainLayout$MenuStyle$", ({
  Lapp_layouts_MainLayout$MenuStyle$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_layouts_MainLayout$MenuStyle$ as $d_Lapp_layouts_MainLayout$MenuStyle$ };
var $n_Lapp_layouts_MainLayout$MenuStyle$;
function $m_Lapp_layouts_MainLayout$MenuStyle$() {
  if ((!$n_Lapp_layouts_MainLayout$MenuStyle$)) {
    $n_Lapp_layouts_MainLayout$MenuStyle$ = new $c_Lapp_layouts_MainLayout$MenuStyle$();
  }
  return $n_Lapp_layouts_MainLayout$MenuStyle$;
}
export { $m_Lapp_layouts_MainLayout$MenuStyle$ as $m_Lapp_layouts_MainLayout$MenuStyle$ };
/** @constructor */
function $c_Lapp_layouts_MainLayout$MenuStyle() {
}
export { $c_Lapp_layouts_MainLayout$MenuStyle as $c_Lapp_layouts_MainLayout$MenuStyle };
$c_Lapp_layouts_MainLayout$MenuStyle.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_layouts_MainLayout$MenuStyle.prototype.constructor = $c_Lapp_layouts_MainLayout$MenuStyle;
/** @constructor */
function $h_Lapp_layouts_MainLayout$MenuStyle() {
}
export { $h_Lapp_layouts_MainLayout$MenuStyle as $h_Lapp_layouts_MainLayout$MenuStyle };
$h_Lapp_layouts_MainLayout$MenuStyle.prototype = $c_Lapp_layouts_MainLayout$MenuStyle.prototype;
$c_Lapp_layouts_MainLayout$MenuStyle.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_layouts_MainLayout$MenuStyle.prototype.hasNotification__Z = (function() {
  var x = $s_Lapp_layouts_MainLayout$MenuStyle$__Simple__Lapp_layouts_MainLayout$MenuStyle();
  if (((x !== null) && (x === this))) {
    return false;
  }
  var x$3 = $s_Lapp_layouts_MainLayout$MenuStyle$__Notification__Lapp_layouts_MainLayout$MenuStyle();
  if (((x$3 !== null) && (x$3 === this))) {
    return true;
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(this);
});
/** @constructor */
function $c_Lapp_layouts_MainLayout$MenuStyle$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.Lapp_layouts_MainLayout$MenuStyle$$anon$1__f_$name$1 = null;
  this.Lapp_layouts_MainLayout$MenuStyle$$anon$1__f__$ordinal$1 = 0;
  this.Lapp_layouts_MainLayout$MenuStyle$$anon$1__f_$name$1 = \u03b4name$2;
  this.Lapp_layouts_MainLayout$MenuStyle$$anon$1__f__$ordinal$1 = _$ordinal$2;
}
export { $c_Lapp_layouts_MainLayout$MenuStyle$$anon$1 as $c_Lapp_layouts_MainLayout$MenuStyle$$anon$1 };
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype = new $h_Lapp_layouts_MainLayout$MenuStyle();
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype.constructor = $c_Lapp_layouts_MainLayout$MenuStyle$$anon$1;
/** @constructor */
function $h_Lapp_layouts_MainLayout$MenuStyle$$anon$1() {
}
export { $h_Lapp_layouts_MainLayout$MenuStyle$$anon$1 as $h_Lapp_layouts_MainLayout$MenuStyle$$anon$1 };
$h_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype = $c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype;
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype.productElement__I__O = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElement__I__O(this, n);
});
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype.productElementName__I__T = (function(n) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype.productPrefix__T = (function() {
  return this.Lapp_layouts_MainLayout$MenuStyle$$anon$1__f_$name$1;
});
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype.toString__T = (function() {
  return this.Lapp_layouts_MainLayout$MenuStyle$$anon$1__f_$name$1;
});
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__hashCode__I(this.Lapp_layouts_MainLayout$MenuStyle$$anon$1__f_$name$1);
});
$c_Lapp_layouts_MainLayout$MenuStyle$$anon$1.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_layouts_MainLayout$MenuStyle$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_layouts_MainLayout$MenuStyle$$anon$1, "app.layouts.MainLayout$MenuStyle$$anon$1", ({
  Lapp_layouts_MainLayout$MenuStyle$$anon$1: 1,
  Lapp_layouts_MainLayout$MenuStyle: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1,
  sr_EnumValue: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_layouts_MainLayout$MenuStyle$$anon$1 as $d_Lapp_layouts_MainLayout$MenuStyle$$anon$1 };
var $t_Lapp_layouts_MainLayout$MenuStyle$__Simple = null;
function $u_Lapp_layouts_MainLayout$MenuStyle$__Simple(x) {
  $t_Lapp_layouts_MainLayout$MenuStyle$__Simple = x;
}
export { $t_Lapp_layouts_MainLayout$MenuStyle$__Simple as $t_Lapp_layouts_MainLayout$MenuStyle$__Simple, $u_Lapp_layouts_MainLayout$MenuStyle$__Simple as $u_Lapp_layouts_MainLayout$MenuStyle$__Simple };
var $t_Lapp_layouts_MainLayout$MenuStyle$__Notification = null;
function $u_Lapp_layouts_MainLayout$MenuStyle$__Notification(x) {
  $t_Lapp_layouts_MainLayout$MenuStyle$__Notification = x;
}
export { $t_Lapp_layouts_MainLayout$MenuStyle$__Notification as $t_Lapp_layouts_MainLayout$MenuStyle$__Notification, $u_Lapp_layouts_MainLayout$MenuStyle$__Notification as $u_Lapp_layouts_MainLayout$MenuStyle$__Notification };
//# sourceMappingURL=app.layouts.-Main-Layout$-Menu-Style.js.map
